import { render, staticRenderFns } from "./orderToKnowledgeBase.vue?vue&type=template&id=4a2d6030&scoped=true&"
import script from "./orderToKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./orderToKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./orderToKnowledgeBase.vue?vue&type=style&index=0&id=4a2d6030&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d6030",
  null
  
)

export default component.exports